import DefaultWindow from './DefaultWindow';

export default DefaultWindow;
